export const PROCESSING_RESULTS = {
  ALL_SUCCEEDED: 'ALL_SUCCEEDED',
  SOME_FAILED: 'SOME_FAILED',
  ALL_FAILED: 'ALL_FAILED',
  APPROVED_SUCCEEDED: 'APPROVED_SUCCEEDED',
  REJECTED_SUCCEEDED: 'REJECTED_SUCCEEDED',
  CHECK_IN_SUCCEEDED: 'CHECK_IN_SUCCEEDED',
};

export const BOOKING_OPERATIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  CANCEL: 'CANCEL',
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  CHECK_IN: 'CHECK_IN',
  DELETE: 'DELETE',
};

export const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
};

export const OPERATION_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

export const DEFAULT_MESSAGES = {
  [PROCESSING_RESULTS.ALL_SUCCEEDED]: {
    [BOOKING_OPERATIONS.CREATE]: 'Booking confirmed successfully!',
    [BOOKING_OPERATIONS.UPDATE]: 'Booking updated successfully!',
    [BOOKING_OPERATIONS.CANCEL]: 'Booking has been cancelled successfully!',
    [BOOKING_OPERATIONS.APPROVE]: 'Booking has been approved successfully!',
    [BOOKING_OPERATIONS.REJECT]: 'Booking has been rejected successfully!',
    [BOOKING_OPERATIONS.CHECK_IN]: 'Check-in completed successfully!',
    [BOOKING_OPERATIONS.DELETE]: 'Booking has been deleted successfully!',
    default: 'Operation completed successfully!',
  },
  [PROCESSING_RESULTS.SOME_FAILED]: {
    default: 'There was an issue with your equipment booking timeslots(s). Please check "My bookings" for more information.',
  },
  [PROCESSING_RESULTS.ALL_FAILED]: {
    default: 'There were problems with booking, please check detailed statuses.',
  },
  [PROCESSING_RESULTS.APPROVED_SUCCEEDED]: {
    default: 'Booking has been approved successfully!',
  },
  [PROCESSING_RESULTS.REJECTED_SUCCEEDED]: {
    default: 'Booking has been rejected successfully!',
  },
};

export const createCallbackConfig = ({
  operation = BOOKING_OPERATIONS.UPDATE,
  onSuccess,
  onError,
  customMessages = {},
  skipNotification = false,
  debounceDelay = 2500,
}) => ({
  operation,
  onSuccess,
  onError,
  customMessages,
  skipNotification,
  debounceDelay,
});
